import { forwardRef } from 'react';

import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';

import { cn } from '@/shared/utils';

const buttonVariants = cva(
  [
    'inline-flex items-center justify-center gap-[10px]',
    'whitespace-nowrap rounded-lg ring-offset-background',
    'font-sans text-sm font-semibold uppercase tracking-wide',
    'transition-all disabled:pointer-events-none disabled:opacity-50',
    // 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
  ],
  {
    variants: {
      variant: {
        default:
          'border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground active:scale-95 rounded-full',
        primary:
          'border border-primary bg-primary text-primary-foreground hover:bg-[#62ff7f] hover:shadow-lg active:scale-95 rounded-full',
        // destructive:
        //   'bg-destructive text-destructive-foreground hover:bg-destructive/90',
        // outline:
        //   'border border-input bg-background hover:bg-accent hover:text-accent-foreground',
        // secondary:
        //   'bg-secondary text-secondary-foreground hover:bg-secondary/80',
        // ghost: 'hover:bg-accent hover:text-accent-foreground',
        link: 'text-primary decoration-2 underline-offset-8 transition-colors hover:text-light hover:underline',
        icon: 'border-0 hover:bg-primary active:bg-primary/60 rounded-full',
      },
      size: {
        sm: 'px-3 py-2',
        base: 'px-5 py-3',
        lg: 'px-10 py-4',
        icon: 'h-16 w-16',
        link: 'p-0',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'base',
    },
  }
);

const Button = forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button';
    return (
      <Comp
        className={cn(
          buttonVariants({
            variant,
            size: variant === 'link' ? 'link' : size,
            className,
          })
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = 'Button';

export default Button;
